import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHealthPlanMappingList } from '../Store/HealthPlanMappingReducer';
import { AppDispatch } from '../Store/StoreInit';
import HealthPlanMappingPg from './HealthPlanMappingPg';
import {
  Button,
  FormLabel,
  HStack,
  Heading,
  Progress,
  Select,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import { IHealthPlanMappingItem } from '../Infrastructure/Interfaces';
import { IoIosSearch } from 'react-icons/io';
import { useMsal } from '@azure/msal-react';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
import {
  fetchHealthPlanTypeList,
  fetchPayerAddressList,
  fetchSceneriosList,
} from '../Store/GetDropDownsValuesReducer';
import { fetchHealthPlanMasterList } from '../Store/HealthPlanMasterReducer';

interface RootState {  
  healthPlanPayerMappedList: {  
    healthPlanMappingList: IHealthPlanMappingItem[];  
    loading: boolean;  
  };  
}  

const HealthPlanMapping: React.FC = () => {  
  const dispatch = useDispatch<AppDispatch>();
  const { healthPlanMappingList, loading } = useSelector((state: RootState) => state.healthPlanPayerMappedList);

  // const healthPlanMappingList: IHealthPlanMappingItem[] = useSelector(
  //   (state: any) => {
  //     return state.healthPlanPayerMappedList.healthPlanMappingList;
  //   }
  // );
  // const loading = useSelector((state: any) => {
  //   return state.healthPlanPayerMappedList.loading;
  // });
  const pageNumber = useSelector((state: any) => {
    return state.setHealthPlanPageNumber.pageNumber;
  });

  const [dataLoading, setDataLoading] = useState(false);

  const [filteredData, setFilteredData] = useState<IHealthPlanMappingItem[]>();

  const [planTypes, setPlanTypes] = useState<string[]>([]);
  const [filteredPayerName, setFilteredPayerName] = useState<string[]>([]);
  const [filteredDisplayName, setFilteredDisplayName] = useState<string[]>([]);

  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  const arrregionlist: string[] = (process.env.REACT_APP_REGION_LIST as string).split(',');

  const [data, setdata] = useState({
    region: '',
    payerName: '',
    displayName: '',
    planType: '',
  });

  useEffect(() => {
    dispatch(fetchHealthPlanMappingList());
    dispatch(fetchPayerMasterList());
    dispatch(fetchHealthPlanTypeList());
    dispatch(fetchSceneriosList());
    dispatch(fetchHealthPlanMasterList());
    dispatch(fetchPayerAddressList());
  }, []);

  useEffect(() => {
    setDataLoading(false);
    if (healthPlanMappingList) {
      setFilteredData(
        healthPlanMappingList.filter(
          (x: any) =>
            x.region == data.region &&
            x.payerName == data.payerName &&
            x.displayName ==
              (data.displayName != '' ? data.displayName : x.displayName) &&
            x.healthPlanType ==
              (data.planType != '' ? data.planType : x.healthPlanType)
        )
      );
    }
  }, [healthPlanMappingList]);

  useEffect(() => {
    setdata(prevData => ({ ...prevData, payerName: '' }));
    if (healthPlanMappingList) {
      const uniquePayerNames = [
        ...new Set(
          healthPlanMappingList
            .filter(rc => rc.region == data.region)
            .map(x => x.payerName)
        ),
      ];
      setFilteredPayerName(uniquePayerNames);
    }
  }, [data.region]);

  useEffect(() => {
    setdata(prevData => ({ ...prevData, displayName: '' }));
    if (healthPlanMappingList) {
      const uniqueDisplayNames = [
        ...new Set(
          healthPlanMappingList
            .filter(
              e => e.region == data.region && e.payerName == data.payerName
            )
            .map(x => x.displayName)
        ),
      ];
      setFilteredDisplayName(uniqueDisplayNames);
    }
  }, [data.payerName]);

  useEffect(() => {
    setdata(prevData => ({ ...prevData, planType: '' }));
    if (healthPlanMappingList) {
      const uniqueplantypes = [
        ...new Set(
          healthPlanMappingList
            .filter(
              e =>
                e.region == data.region &&
                e.payerName == data.payerName &&
                e.displayName == data.displayName
            )
            .map(x => x.healthPlanType)
        ),
      ];
      setPlanTypes(uniqueplantypes);
    }
  }, [data.displayName]);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata(prevData => ({ ...prevData, [id]: value }));
  };

  const getFilterData = (e: any) => {
    setDataLoading(true);
    setFilteredData(
      healthPlanMappingList.filter(
        (x: any) =>
          x.region == data.region &&
          x.payerName == data.payerName &&
          x.displayName ==
            (data.displayName != '' ? data.displayName : x.displayName) &&
          x.healthPlanType ==
            (data.planType != '' ? data.planType : x.healthPlanType)
      )
    );
  };

  return (
    <>
      <HStack>
        <FormLabel>Region</FormLabel>
        <Select
          width={60}
          placeholder="--select Region--"
          name="region"
          id="region"
          onChange={e => handleChange(e)}
        >
          {arrregionlist?.map(region => (
              <option key={region} value={region}>
                {region}
              </option>
            ))}
        </Select>

        <FormLabel>Payer Name</FormLabel>
        <Select
          width={48}
          placeholder="--select--"
          name="payerName"
          id="payerName"
          onChange={e => handleChange(e)}
          value={data.payerName}
        >
          {Array.isArray(filteredPayerName) &&
            filteredPayerName.map((payername: any, index: any) => (
              <option key={index + '_' + payername} value={payername}>
                {payername}
              </option>
            ))}
        </Select>

        <FormLabel>Display Name</FormLabel>
        <Select
          width={48}
          placeholder="--select--"
          name="displayName"
          id="displayName"
          onChange={e => handleChange(e)}
          value={data.displayName}
        >
          {Array.isArray(filteredDisplayName) &&
            filteredDisplayName.map((displayname: any, index: any) => (
              <option key={index + '_' + displayname} value={displayname}>
                {displayname}
              </option>
            ))}
        </Select>

        <FormLabel>Plan Type</FormLabel>
        <Select
          width={48}
          placeholder="--select--"
          name="planType"
          id="planType"
          onChange={e => handleChange(e)}
          value={data.planType}
        >
          {Array.isArray(planTypes) &&
            planTypes.map((x: any, index: any) => (
              <option key={index + '_' + x} value={x}>
                {x}
              </option>
            ))}
        </Select>

        <Button
          isDisabled={data.region != '' && data.payerName != '' ? false : true}
          ml="1rem"
          variant="outline"
          size="md"
          leftIcon={<IoIosSearch />}
          onClick={e => getFilterData(e)}
        >
          Search
        </Button>
      </HStack>

      {loading ? (
        <>
          {dataLoading && (
            <Stack padding={5} mt={20}>
              <Progress hasStripe value={64} isIndeterminate />
            </Stack>
          )}
        </>
      ) : !filteredData ? (
        <Heading>Data not found...</Heading>
      ) : (
          <HealthPlanMappingPg
            healthPlanMappingLists={filteredData}
            region={data.region}
          />
      )}
    </>
  );
}

export default HealthPlanMapping;
